module.exports = __webpack_public_path__ + "static/img/dtitle0.a086c53.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/dtitle0.png
// module id = Ov2J
// module chunks = 0